/**
 * Created by Jerker Nord on 2020-07-02.
 */
import {WinPresentationController} from "@nolimitcity/slot-game/bin/core/winpresentation/WinPresentationController";
import {TimelineLite} from "gsap";
import {IExistingBigSymbols} from "../../server/data/IExistingBigSymbols";
import {MonkeysGoldParsedGameData} from "../../server/data/MonkeysGoldParsedGameData";
import {MonkeysGoldGameModuleConfig} from "../../MonkeysGoldGameModuleConfig";
import {StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {MonkeysGoldReelSymbol} from "../../symbols/MonkeysGoldReelSymbol";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {MonkeysGoldParsedInitData} from "../../server/data/MonkeysGoldParsedInitData";
import {GameMode} from "@nolimitcity/slot-game/bin/core/gamemode/GameMode";
import {INolimitAudioPlayer} from "@nolimitcity/slot-audio/bin/INolimitAudioPlayer";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {MonkeysGoldSoundConfig} from "../../MonkeysGoldSoundConfig";

export class MonkeysGoldRowLockWPController extends WinPresentationController {

    private _previousNumberOfUpgrades:number;
    private _numberOfUpgrades:number = 0;
    private _lockedRows:boolean[] = [false, false, false, false, false, false];
    private _reelsAfterCollapseUpgraded:string[][];
    private _upgradePositionsAfterCollapse:boolean[][];
    private _rowLockTL:TimelineLite;
    private _fsMultiplierAfter:number;
    private _fsMultiplierBefore:number;
    private _upgrade2x2Symbols:boolean[][] = [];
    private _upgrade3x3Symbols:boolean[][] = [];
    private _reels:string[][];
    private _bigSymbolsAfterSpin:IExistingBigSymbols[];
    private _fsMultiplierIncrease:number;
    private _mode:string;
    private _nextMode:string;
    private _reelsAfterCollapse:string[][];
    private _allWinPositions:boolean[][];

    constructor(indexes:[number, number]) {
        super(indexes, {name : "MonkeysGoldRowLockController", skippable : false});
    }

    protected parseFeatureGameData(data:MonkeysGoldParsedGameData):void {
        this._previousNumberOfUpgrades = this._numberOfUpgrades;
        this._numberOfUpgrades = data.numberOfUpgrades;
        this._reelsAfterCollapseUpgraded = data.reelsAfterCollapseUpgraded;
        this._upgradePositionsAfterCollapse = data.upgradePositionsAfterCollapse;
        this._fsMultiplierAfter = data.fsMultiplierAfter;
        this._fsMultiplierBefore = data.fsMultiplierBefore;
        this._upgrade2x2Symbols = data.upgrade2x2Symbols;
        this._upgrade3x3Symbols = data.upgrade3x3Symbols;
        this._bigSymbolsAfterSpin = data.bigSymbolsAfterSpin;
        this._reels = data.reels;
        this._reelsAfterCollapse = data.reelsAfterCollapse;
        this._fsMultiplierIncrease = data.fsMultiplierIncrease;
        this._mode = data.mode;
        this._nextMode = data.nextMode;
        this._allWinPositions = data.allWinPositions;
    }

    protected addFeatureEventHandlers() {
        EventHandler.addEventListener(this, ServerEvent.INIT_DATA_PARSED, (event:GameEvent) => this.onInitDataParsed(event.params[0]));
    }

    private onInitDataParsed(data:MonkeysGoldParsedInitData):void {
        this._bigSymbolsAfterSpin = data.existingBigSymbols;
        this._mode = data.mode;
        this._nextMode = data.nextMode;
    }

    protected hasWin():boolean {
        if(this._numberOfUpgrades > 0 && (this._nextMode == GameMode.NORMAL || ((this._mode == GameMode.NORMAL || GameMode.NORMAL_AVALANCHE) && this._nextMode == GameMode.FREESPIN))) {
            return true;
        } else {
            return false;
        }
    }

    //This is only played if we get full reels of win syms
    protected startWinPresentation():void {
        const fullReelsWinTL:TimelineLite = new TimelineLite();
        fullReelsWinTL.add(this.getRowLockAnimationTL());
        fullReelsWinTL.add(() => this.upgradeReels());
        fullReelsWinTL.add(() => MonkeysGoldGameModuleConfig.monkeysGoldRowLockView.resetAllAnimations(), "+=1.5");
        fullReelsWinTL.add(() => MonkeysGoldGameModuleConfig.monkeysGoldSymbolUpgradeView.abort(this._reels));
        fullReelsWinTL.add(() => this.cleanUp());
        fullReelsWinTL.add(() => this.finish());
    }

    public getRowLockAnimationTL():TimelineLite {
        if(this._numberOfUpgrades > 0) {
            return this.rowLockAnimation();
        } else {
            return new TimelineLite();
        }
    }

    private rowLockAnimation():TimelineLite {
        const rowLockNumber:number = this.getLockRow();
        this._rowLockTL = new TimelineLite();
        this._rowLockTL.add(new TimelineLite({delay : 0.3}));
        const allSmokeTLs:TimelineLite[] = [];

        //Remove colossals from 1x1 upgrades
        for(let i:number = 0; i < this._upgrade2x2Symbols.length; i++) {
            for(let j:number = 0; j < this._upgrade2x2Symbols[i].length; j++) {
                if(this._upgrade2x2Symbols[i][j] == true) {
                    this._upgradePositionsAfterCollapse[i][j] = false;
                }
            }
        }
        for(let i:number = 0; i < this._upgrade3x3Symbols.length; i++) {
            for(let j:number = 0; j < this._upgrade3x3Symbols[i].length; j++) {
                if(this._upgrade3x3Symbols[i][j] == true) {
                    this._upgradePositionsAfterCollapse[i][j] = false;
                }
            }
        }

        for(let i:number = 0; i < this._numberOfUpgrades; i++) {
            allSmokeTLs.push(MonkeysGoldGameModuleConfig.monkeysGoldRowLockView.getYellowSmokeAnimation(rowLockNumber - i));
        }

        allSmokeTLs.push(MonkeysGoldGameModuleConfig.monkeysGoldSymbolUpgradeView.get1x1TurnAnimation(this._upgradePositionsAfterCollapse, this._reelsAfterCollapseUpgraded, this._reelsAfterCollapse));

        //Check all reels for colossals to turn
        for(let j:number = 0; j < 6; j++) {
            let symbolsOnReel:StateReelSymbol[] = Reels.getReel(j)!.allSymbols;
            if(symbolsOnReel) {
                for(let i:number = 0; i < symbolsOnReel.length; i++) {
                    if(symbolsOnReel[i].symName.indexOf("colossalx2") > -1 && this._allWinPositions[j][i] == true) {
                        const finalMultiplier:number = this.findBigSymbolFinalMultiplier((<MonkeysGoldReelSymbol>symbolsOnReel[i]).bottomLeftPosition);
                        if(finalMultiplier > -1) {
                            (<MonkeysGoldReelSymbol>symbolsOnReel[i]).bigSymbolFinalMultiplier = finalMultiplier;
                        }
                        allSmokeTLs.push((<MonkeysGoldReelSymbol>symbolsOnReel[i]).playColossalUpgradeAnimation("2", this.findBigSymbolTargetSymName((<MonkeysGoldReelSymbol>symbolsOnReel[i]).bottomLeftPosition)));
                    }
                    if(symbolsOnReel[i].symName.indexOf("colossalx3") > -1 && this._allWinPositions[j][i] == true) {
                        const finalMultiplier:number = this.findBigSymbolFinalMultiplier((<MonkeysGoldReelSymbol>symbolsOnReel[i]).bottomLeftPosition);
                        if(finalMultiplier > -1) {
                            (<MonkeysGoldReelSymbol>symbolsOnReel[i]).bigSymbolFinalMultiplier = finalMultiplier;
                        }
                        allSmokeTLs.push((<MonkeysGoldReelSymbol>symbolsOnReel[i]).playColossalUpgradeAnimation("3", this.findBigSymbolTargetSymName((<MonkeysGoldReelSymbol>symbolsOnReel[i]).bottomLeftPosition)));
                    }
                }
            }
        }

        this._rowLockTL.add(allSmokeTLs);

        for(let i:number = 0; i < this._numberOfUpgrades; i++) {
            let playSound:boolean = true;
            if(i > 0) {
                playSound = false;
            }
            let newMultiplierValue:number = this._fsMultiplierBefore + ((i + 1) * this._fsMultiplierIncrease);
            this._rowLockTL.add([
                MonkeysGoldGameModuleConfig.monkeysGoldRowLockView.getVineAnimation(rowLockNumber - i), "-=0.2",
                () => {
                    if(this._fsMultiplierAfter == 1) {
                        if(playSound == true) {
                            (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SYMBOLS_LOCK)})
                        }
                    } else {
                        (<INolimitAudioPlayer>SlotGame.sound).playTrack({name : (MonkeysGoldSoundConfig.instance.SYMBOLS_LOCK)})
                    }
                }
            ]);
            if(this._fsMultiplierAfter > 1) {
                this._rowLockTL.add(MonkeysGoldGameModuleConfig.monkeysGoldBonusGameMultiplierView.setMultiplierValue(newMultiplierValue, this._fsMultiplierIncrease, false, playSound));
            }
        }

        if(this._numberOfUpgrades > 1) {
            for(let i:number = 0; i < this._numberOfUpgrades - 1; i++) {
                this.getLockRow();
            }
        }
        return this._rowLockTL;
    }

    private findBigSymbolFinalMultiplier(bottomLeftPosition:number[]):number {
        let finalMultiplier:number = -1;
        for(let i:number = 0; i < this._bigSymbolsAfterSpin.length; i++) {
            if(this._bigSymbolsAfterSpin[i].bottomLeftPosition[0] == (bottomLeftPosition[0] - (this._bigSymbolsAfterSpin[i].symbolSize - 1)) && this._bigSymbolsAfterSpin[i].bottomLeftPosition[1] == bottomLeftPosition[1]) {
                finalMultiplier = this._bigSymbolsAfterSpin[i].symbolFinalMultiplier;
                break;
            }
        }
        return finalMultiplier;
    }

    private findBigSymbolTargetSymName(bottomLeftPosition:number[]):string {
        let targetSym:string = "";
        for(let i:number = 0; i < this._bigSymbolsAfterSpin.length; i++) {
            if(this._bigSymbolsAfterSpin[i].bottomLeftPosition[0] == (bottomLeftPosition[0] - (this._bigSymbolsAfterSpin[i].symbolSize - 1)) && this._bigSymbolsAfterSpin[i].bottomLeftPosition[1] == bottomLeftPosition[1]) {
                targetSym = this._bigSymbolsAfterSpin[i].symbol;
                break;
            }
        }
        return targetSym;
    }


    // @ts-ignore
    private getLockRow():number {
        for(let i:number = 0; i < this._lockedRows.length; i++) {
            if(this._lockedRows[i] == false) {
                this._lockedRows[i] = true;
                return 5 - i;
            }
        }
    }

    //Only on restore
    public setLockedRows(rows:number):void {
        for(let i:number = 0; i < rows; i++) {
            this._lockedRows[i] = true;
        }
    }

    private upgradeReels():void {
        for(let i:number = 0; i < this._reelsAfterCollapseUpgraded.length; i++) {
            for(let j:number = 0; j < this._reelsAfterCollapseUpgraded[i].length; j++) {
                this._reels[i][j] = this._reelsAfterCollapseUpgraded[i][j];
            }
        }
    }

    public cleanUp():void {
        if(this._rowLockTL && this._rowLockTL.isActive() == true) {
            this._rowLockTL.pause();
            this._rowLockTL.kill();
        }
        for(let i:number = 0; i < this._lockedRows.length; i++) {
            this._lockedRows[i] = false;
        }
    }

    protected stopWinPresentation(isAborted:boolean):void {
        if(isAborted == true) {

        }
    }
}